import { render, staticRenderFns } from "./CrudRead.vue?vue&type=template&id=1afa2e26&"
import script from "./CrudRead.vue?vue&type=script&lang=js&"
export * from "./CrudRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports